import { map } from 'rxjs/operators';
import { Injector } from '@angular/core';

import { SgEntityFetchAdapter } from '../components/entity-select-auto-complete';
import { validateArrayType } from './utils/validate-array';
import { InstrumentsManagerApi, InstrumentsManagerApiClient } from '@sg/api/instruments-manager-api';

declare module '../components/entity-select-auto-complete/entity-select-fetch-store.service' {
  export interface SgEntitySelectEntityFetchMap {
    Isin: {
      entity: InstrumentsManagerApi.InstrumentDto;
      query: InstrumentsManagerApi.InstrumentSearchParamsDto;
    };
  }
}

export class IsinApiToEntityFetcherLink implements SgEntityFetchAdapter<'Isin'> {
  readonly key: 'Isin' = 'Isin';
  readonly metadata: {
    idField: keyof InstrumentsManagerApi.InstrumentDto;
    labelField: keyof InstrumentsManagerApi.InstrumentDto;
    queryField?: { field: keyof InstrumentsManagerApi.InstrumentSearchParamsDto; isArray?: boolean };
  } = {
    idField: 'data.currentIdentifiers.isin' as any,
    labelField: 'data.currentIdentifiers.isin' as any,
    queryField: { field: 'isins', isArray: true },
  };

  private readonly instrumentsManagerApi: InstrumentsManagerApiClient;

  constructor(injector: Injector) {
    this.instrumentsManagerApi = injector.get(InstrumentsManagerApiClient);
  }

  getEntity(isins: string[]) {
    const body: InstrumentsManagerApi.InstrumentSearchParamsDto = { isins: validateArrayType(isins) };
    return this.instrumentsManagerApi
      .instrumentsManagerControllerPostInstrumentsSearch(
        { body, pageNumber: 1, sortDirection: 'asc' },
        { observe: 'body' }
      )
      .pipe(map((results) => results.rows));
  }

  findEntities(query?: InstrumentsManagerApi.InstrumentSearchParamsDto & { name: string[] }, pageNumber?: number) {
    const body: InstrumentsManagerApi.InstrumentSearchParamsDto = {};

    if (query) {
      Object.assign(body, query);
    }

    return this.instrumentsManagerApi
      .instrumentsManagerControllerPostInstrumentsSearch(
        { body, pageSize: 10, pageNumber: pageNumber ?? 1, sortDirection: 'asc' },
        { observe: 'body' }
      )
      .pipe(
        map((result) => {
          return {
            data: result.rows ? result.rows : [],
            infiniteScrollInfo: { currentPage: result.paging.pageNumber, totalPages: result.paging.totalPages },
          };
        })
      );
  }
}
